export enum CompareTarget {
  BASELINE = 'baseline',
  COMPARISON = 'comparison',
}
